export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'cl',
  messages: {
    cl: {
      welcome: 'Bienvenido a plataforma Copec.',
      nationalResult: 'Resultado país',
      layout: {
        userMenu: {
          profile: 'Perfil',
          notifications: 'Notificaciones',
          login: 'Iniciar sesión',
          logout: 'Cerrar sesión',
        },
        navbar: {
          dashboard: 'Panel',
          report: 'Reporte',
          manuals: 'Manuales',
          admin: 'Administración',
        },
        buttons: {
          expand: 'Expandir',
          contract: 'Contraer',
          confirm: 'Confirmar',
          seeAll: 'Ver todas',
          upload: 'Cargar',
        }
      },
      manuals: {
        images: {
          descriptionTtip: 'Gestión de imágenes',
          selectTtip: 'Seleccionar imágenes',
          selectionTtip: 'Seleccionar imágenes para',
          deleteTtip: 'Eliminar imágenes',
          upload: 'Cargar imagen'
        },
        admin: 'Administración',
        comply: 'Cumple',
        dontComply: 'No cumple',
      },
      for: 'para',
      mensual: 'Mensual',
      anual: 'Anual',
      barra: 'Barra',
      calle: 'Calle',
      universidad: 'Universidad',
      ano: 'Anual',
      trimestre: 'Trimestral',
      semestre: 'Semestral',
      mes: 'Mensual',
      semana: 'Semanal',
      dia: 'Diario',
      conglomerado: 'Conglomerado',
      zone_leader: 'Jefe Zona',
      commercial_leader: 'Jefe Comercial',
      consultant: 'Consultor',
      operations_manager: 'Jefe Operaciones',
      office: 'Oficina',
      chart011: {
        group1: 'ISN',
        group2: '% Menciones',
        group3: 'Aporte Marginal',
        group4: 'Máximo Aporte Marginal',
        group5: 'Potencial Acción'
      },
      chart012: {
        group1: '% ISN PaC',
        group2: '% ISN PB',
        group3: 'Δ ISN',
        group4: '% Menciones PaC',
        group5: '% Menciones PB',
        group6: 'Δ% Menciones',
        group7: 'Aporte Marginal PaC',
        group8: 'Aporte Marginal PB',
        group9: 'Δ Aporte Marginal',
        group10: 'Diferencia Significativa'
      },
      chart013: {
        isn_branch_1: 'Comparativo ISN Tiendas',
        isn_branch_2: 'Comparativo ISN Estación de Servicio'
      },
      chart016: 'Evolutivo ISN Tiempo de Espera',
      chart017: 'Evolutivo ISN Amabilidad',
      chart018: 'Evolutivo ISN Rapidez Comida',
      chart019: 'Evolutivo ISN Calidad Comida',
      chart020: 'Evolutivo ISN Baño',
      chart021: 'Evolutivo NPS',
      navbar: {
        home: 'Inicio',
        dashboard: 'Panel'
      },
      enter: 'Entrar',
      session_time: 'Tiempo de sesión',
      theme: 'Alternar tema Claro / Oscuro',
      filters: 'Filtros',
      analytics: 'Analytics',
      attributes: 'Atributos',
      microdrivers: 'Micropalancas',
      nps: 'NPS',
      summary: 'Resumen',
      subpanels: 'Subpaneles',
      show: 'Ver',
      clear: 'Limpiar',
      p201: 'Tiempo de Espera',
      p202: 'Amabilidad',
      p203: 'Rapidez Comida',
      p204: 'Calidad Comida',
      p205: 'Baño',
      p301: 'Recomendación',
      tiempo_de_espera: 'Tiempo de Espera',
      amabilidad: 'Amabilidad',
      rapidez_comida: 'Rapidez Comida',
      calidad_comida: 'Calidad Comida',
      bano: 'Baño',
      recomendacion: 'Recomendación',
      general: 'General',
      send: 'Enviados',
      remindersend: 'Recordatorios',
      service_report: {
        chart001: {
          report_service_title_001: 'Índices de Satisfacción'
        },
        chart002: {
          isc: 'ISC',
          igs: 'IGS',
          icp: 'ICP',
          isn: 'ISN',
          iscacciona: 'ISC Acciona',
          igsacciona: 'IGS Acciona',
          isn_acciona: 'ISN Acciona'
        },
        chart004: {
          fuera_de_plazo: 'Fuera de plazo',
          apelada: 'Apelada',
          deleted: 'Eliminada',
        },
        satisfaccion: 'Satisfacción',
        amabilidad: 'Amabilidad',
        experiencia: 'Experiencia',
        sentimiento: 'Sentimiento',
        tiempo: 'Tiempo',
        razon: 'Razón',
        eds_paso_1: 'Saludo',
        eds_paso_2: 'Oferta de producto',
        eds_paso_3: 'Mostrar Surtidr En 0',
        eds_paso_4: 'Invitación App Copec',
        eds_paso_5: 'Limpieza De Vidrios',
        eds_paso_6: 'Comunicación Promociones',
        eds_paso_7: 'Monto / Método / Calidad',
        eds_paso_8: 'Programa Fidelidad',
        eds_paso_9: 'Despedida',
        eds_paso_7_7: 'Calidad / Rendimiento',
        eds_paso_7_8: 'Rut para descuento',
        tienda_paso_1: 'Saludo',
        tienda_paso_2: 'Venta Sugerida',
        tienda_paso_3: 'Cuenta Con App Copec',
        tienda_paso_4: 'Paga Con App Copec',
        tienda_paso_5: 'Fidelización',
        tienda_paso_6: 'Servicio Complementario',
        tienda_paso_7: 'Higiene',
        tienda_paso_8: 'Número De Pedido',
        tienda_paso_9: 'Entrega',
        tienda_paso_10: 'Despedida',
        isc: 'ISC',
        isn: 'ISN',
        tiempo_espera_fila: 'Tiempo Espera Fila',
        funcionamiento_hidrolavadora: 'Funcionamiento Hidrolavadora',
        amabilidad_atendedor: 'Amabilidad del atendedor',
        resultado_lavado: 'Resultado del lavado',
        servicio_aspirado: 'Servicio de aspirado',
        capacidades_tecnicas: 'Capacidades Técnicas',
        tiempo_atencion: 'Tiempo Atención',
        servicio_cambio_aceite: 'Servicio Cambio Aceite',
        logre_necesitaba: 'Logré lo que necesitaba',
        anfitrion: 'Satisfacción Anfitrión',
        facilidad_scango: 'Facilidad sistema "Scan&Go"',
        rapidez_scango: 'Rapidez sistema "Scan&Go"',
        sabor_comida: 'Sabor Comida',
        temperatura_comida: 'Temperatura Comida',
        precio_comida: 'Precio Comida',
        bano: 'Baño',
        rapidez_comida: 'Rapidez Comida',
        calidad_comida: 'Calidad Comida',
        comentario_servicio_aspirado: 'Comentario Servicio Aspirado',
      },
      image_report: {
        total: 'Total',
        total_sin_infra: 'Total sin Infraestructura',
        concesionario: 'Concesionario',
        oficina: 'Oficina',
        infraestructura: 'Infraestructura',
      }
    },
    us: {
      welcome: 'Welcome to Copec Platform',
      nationalResult: 'National Result',
      layout: {
        userMenu: {
          profile: 'Profile',
          notifications: 'Notifications',
          login: 'Login',
          logout: 'Logout',
        },
        navbar: {
          dashboard: 'Dashboard',
          report: 'Report',
          manuals: 'Manuals',
          admin: 'Administration',
        },
        buttons: {
          expand: 'Expand',
          contract: 'Contract',
          confirm: 'Confirm',
          seeAll: 'See all',
          upload: 'Upload',
        }
      },
      manuals: {
        images: {
          descriptionTtip: 'Images settings',
          selectTtip: 'Images selection',
          selectionTtip: 'Select images for ',
          deleteTtip: 'Delete images',
          upload: 'Upload image'
        },
        admin: 'Manual Settings',
        comply: 'Comply',
        dontComply: "Don't comply",
      },
      for: 'for',
      anual: 'Anually',
      mensual: 'Monthly',
      barra: 'Bar',
      calle: 'Street',
      universidad: 'University',
      ano: 'Year',
      trimestre: 'Trimester',
      semestre: 'Semester',
      mes: 'Month',
      semana: 'Week',
      dia: 'Day',
      conglomerado: 'Conglomerado',
      zone_leader: 'Jefe Zona',
      commercial_leader: 'Jefe Comercial',
      consultant: 'Consultor',
      operations_manager: 'Jefe Operaciones',
      office: 'Oficina',
      chart011: {
        group1: 'ISN',
        group2: '% Menciones',
        group3: 'Aporte Marginal',
        group4: 'Máximo Aporte Marginal',
        group5: 'Potencial Acción'
      },
      chart012: {
        group1: '% ISN PaC',
        group2: '% ISN PB',
        group3: 'Δ ISN',
        group4: '% Menciones PaC',
        group5: '% Menciones PB',
        group6: 'Δ% Menciones',
        group7: 'Aporte Marginal PaC',
        group8: 'Aporte Marginal PB',
        group9: 'Δ Aporte Marginal',
        group10: 'Diferencia Significativa'
      },
      chart013: {
        isn_branch_1: 'Comparativo ISN Tiendas',
        isn_branch_2: 'Comparativo ISN Estación de Servicio'
      },
      chart016: 'Evolutivo ISN Waiting Time',
      chart017: 'Evolutivo ISN Gentleness',
      chart018: 'Evolutivo ISN Food Quickness',
      chart019: 'Evolutivo ISN Food Quality',
      chart020: 'Evolutivo ISN Bathroom',
      chart021: 'Evolutivo NPS',
      navbar: {
        home: 'Home',
        dashboard: 'Dashboard'
      },
      enter: 'Enter',
      session_time: 'Session time',
      theme: 'Light / Dark theme',
      filters: 'Filters',
      analytics: 'Analytics',
      attributes: 'Attributes',
      microdrivers: 'Microdrivers',
      nps: 'NPS',
      summary: 'Summary',
      subpanels: 'Subpanels',
      show: 'Show',
      clear: 'Clear',
      tiempo_de_espera: 'Tiempo de Espera',
      amabilidad: 'Amabilidad',
      rapidez_comida: 'Rapidez Comida',
      calidad_comida: 'Calidad Comida',
      bano: 'Baño',
      recomendacion: 'Recomendación',
      general: 'General',
      send: 'Enviados',
      remindersend: 'Recordatorios',
      service_report: {
        chart001: {
          report_service_title_001: 'Índices de Satisfacción'
        },
        chart002: {
          isc: 'ISC',
          igs: 'IGS',
          icp: 'ICP',
          isn: 'ISN',
          iscacciona: 'ISC Acciona',
          igsacciona: 'IGS Acciona',
          isn_acciona: 'ISN Acciona'
        },
        chart004: {
          fuera_de_plazo: 'Out of date',
          apelada: 'Appealed',
          deleted: 'Deleted',
        },
        satisfaccion: 'Satisfacción',
        amabilidad: 'Amabilidad',
        experiencia: 'Experiencia',
        sentimiento: 'Sentimiento',
        tiempo: 'Tiempo',
        razon: 'Razón',
        eds_paso_1: 'Saludo',
        eds_paso_2: 'Confirmación Monto',
        eds_paso_3: 'Mostro Surtidor En 0',
        eds_paso_4: 'Invitación App Copec',
        eds_paso_5: 'Limpieza De Vidrios',
        eds_paso_6: 'Promoción Adicional',
        eds_paso_7: 'Confirmación Pago',
        eds_paso_8: 'Punto Full Copec',
        eds_paso_9: 'Despedida',
        eds_paso_7_7: 'Calidad / Rendimiento',
        eds_paso_7_8: 'Rut para descuento',
        tienda_paso_1: 'Saludo',
        tienda_paso_2: 'Venta Sugerida',
        tienda_paso_3: 'Cuenta Con App Copec',
        tienda_paso_4: 'Paga Con App Copec',
        tienda_paso_5: 'Fidelización',
        tienda_paso_6: 'Servicio Complementario',
        tienda_paso_7: 'Higiene',
        tienda_paso_8: 'Número De Pedido',
        tienda_paso_9: 'Entrega',
        tienda_paso_10: 'Despedida',
        isc: 'ISC',
        isn: 'ISN',
        tiempo_espera_fila: 'Tiempo Espera Fila',
        funcionamiento_hidrolavadora: 'Funcionamiento Hidrolavadora',
        amabilidad_atendedor: 'Amabilidad del atendedor',
        resultado_lavado: 'Resultado del lavado',
        servicio_aspirado: 'Servicio de aspirado',
        capacidades_tecnicas: 'Capacidades Técnicas',
        tiempo_atencion: 'Tiempo Atención',
        servicio_cambio_aceite: 'Servicio Cambio Aceite',
        logre_necesitaba: 'Logré lo que necesitaba',
        anfitrion: 'Satisfacción Anfitrión',
        facilidad_scango: 'Facilidad sistema "Scan&Go"',
        rapidez_scango: 'Rapidez sistema "Scan&Go"',
        sabor_comida: 'Sabor Comida',
        temperatura_comida: 'Temperatura Comida',
        precio_comida: 'Precio Comida',
        bano: 'Baño',
        rapidez_comida: 'Rapidez Comida',
        calidad_comida: 'Calidad Comida',
        comentario_servicio_aspirado: 'Comentario Servicio Aspirado',
      },
      image_report: {
        total: 'Total',
        total_sin_infra: 'Total sin Infraestructura',
        concesionario: 'Concesionario',
        oficina: 'Oficina',
        infraestructura: 'Infraestructura',
      }

    },
  }
}))
